import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, ChevronDownIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { ui } from '../data/ui';
import type { PaintingService } from '../types/content';
type ServiceCardProps = {
  service: PaintingService;
  featured?: boolean;
};
export function ServiceCard({
  service,
  featured = false
}: ServiceCardProps) {
  const {
    t
  } = useLanguage();
  const [open, setOpen] = useState(false);
  const panelId = `service-more-${service.id}`;
  return <article className={`flex overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-line ${featured ? 'flex-col lg:col-span-2 lg:grid lg:grid-cols-2' : 'flex-col'}`} data-id="element-280" data-mp="39a7thlw5w4ls">
      <div className={`relative overflow-hidden ${featured ? 'aspect-[16/10] lg:aspect-auto lg:min-h-[400px]' : 'aspect-[16/10]'}`} data-id="element-281" data-mp="3j9fix7g67pp9">
        <img src={service.image} alt={t(service.alt)} loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-282" data-mp="3o8s4zpz7wsqs" />
        {featured && <span className="absolute left-4 top-4 rounded-md bg-leaf-strong px-2.5 py-1 text-xs font-bold text-white" data-id="element-283" data-mp="1zapcxviojwyp">{t(ui.services.mostRequested)}</span>}
      </div>

      <div className={`flex flex-1 flex-col p-6 md:p-8 ${featured ? 'lg:p-10' : ''}`} data-id="element-284" data-mp="1udp45cug4g3w">
        <h3 className={`font-display font-bold text-ink ${featured ? 'text-2xl md:text-[28px]' : 'text-xl md:text-2xl'}`} data-id="element-285" data-mp="1qbu1o50s3woj">{t(service.title)}</h3>
        <p className="mt-3 leading-relaxed text-body" data-id="element-286" data-mp="2i0ou7w8a47rk">{t(service.description)}</p>
        <ul className="mt-6 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-287" data-mp="2dagv88g8bzii">
          {service.points.map(p => <li key={p.en} className="flex items-start gap-2 text-[15px] text-ink" data-id="element-288" data-mp="29950xpmeuq3z">
              <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-leaf-strong" aria-hidden="true" data-id="element-289" data-mp="2972ax5l9cwz9" />
              {t(p)}
            </li>)}
        </ul>

        <AnimatePresence initial={false} data-id="element-290" data-mp="30z9lboa67d57">
          {open && <motion.div id={panelId} initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} className="overflow-hidden" data-id="element-291" data-mp="z1zcp927cpfj">
              <p className="mt-5 border-l-2 border-leaf pl-4 leading-relaxed text-body" data-id="element-292" data-mp="uahir4yljp42">{t(service.more)}</p>
            </motion.div>}
        </AnimatePresence>

        <div className="mt-auto flex flex-wrap items-center gap-x-6 gap-y-3 pt-8" data-id="element-293" data-mp="lbnjt7xsmmnc">
          <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls={panelId} className="btn btn-navy min-h-[48px]" data-id="element-294" data-mp="6e3icb03v9lx">
            {open ? t(ui.services.showLess) : t(ui.services.learnMore)}
            <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-295" data-mp="25qpfuqv9e88c" />
          </button>
          <a href="#contact" className="inline-flex items-center gap-1.5 text-sm font-semibold text-leaf-strong underline-offset-4 hover:underline" data-id="element-296" data-mp="3q9jg5xykyin0">
            {t(ui.services.getEstimate)}
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-297" data-mp="3u73zpsmjoaj" />
          </a>
        </div>
      </div>
    </article>;
}